import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// components
import Header from "../Header/Header";
import MobileHeader from "../Header/MobileHeader";
import SocialMediaLinks from "../Globals/SocialMediaLinks";
import SocialMenuLg from "../Globals/SocialMenuLg";
import SocialMenuMd from "../Globals/SocialMenuMd";
import Footer from "../Footer/Footer";

// components
import Loader from "../Globals/Loader";

// custom hooks
import useTheme from "../../hooks/useTheme";

const PageLayout = ({ children }) => {
	const { pathname } = useLocation();
	const { theme } = useTheme();
	const [loading, setLoading] = useState(false);

	return (
		<div
			className={`min-h-screen max-w-screen ${
				pathname === "/about" ? "" : "overflow-hidden"
			} ${
				theme === "dark" ? "bg-black text-white" : "bg-white text-black"
			} transition-all duration-500 font-serif`}>
			<Header />
			<MobileHeader />
			<div className="flex flex-col items-center justify-center">
				{children}
			</div>
			<SocialMenuLg />
			<SocialMenuMd />
			<Footer />
		</div>
	);
};

export default PageLayout;
